exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub-heading-buttons-container---13DG1 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: 14px; }\n  .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG {\n    margin-left: 5px;\n    font-size: 14px; }\n  .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG .download-btn---1FHWj,\n    .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG .export-btn---2QJkF {\n      height: 28px; }\n", ""]);

// exports
exports.locals = {
	"sub-heading-buttons-container": "sub-heading-buttons-container---13DG1",
	"sub-heading-btn": "sub-heading-btn---BtAAG",
	"download-btn": "download-btn---1FHWj",
	"export-btn": "export-btn---2QJkF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/sub-heading/sub-heading-buttons/sub-heading-buttons.scss
// module id = JZdf
// module chunks = 1